module.exports = __webpack_public_path__ + "img/mission.31f5435c.svg";